import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useAuth } from '../../../context/AuthContext';
import { toast } from '../../../components/ui/toast';
import { fetchWithAuth } from '../../../utils/fetchWithAuth';

const API = process.env.REACT_APP_API_BASE;

export default function ReplyBotWhatsappCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { user } = useAuth();

  useEffect(() => {
    const query = new URLSearchParams(location.search);
    const code = query.get('code');

    if (!code) {
        toast('Missing WhatsApp authorization code.', 'error');
      navigate('/replybot/onboarding');
      return;
    }

    const callBackendCallback = async () => {
      try {
        const response = await fetchWithAuth(`${API}/api/replybot/whatsapp/callback?code=${code}`, {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${user?.token}`,
          },
        });

        const data = await response.text(); // since your API sends plain text

        if (!response.ok) throw new Error(data || 'Failed to connect WhatsApp');

        toast('✅ WhatsApp connected successfully!');
        navigate('/apps/replybot/onboarding');
      } catch (err) {
        toast(`❌ WhatsApp connection failed: ${err.message}`, 'error');
        navigate('/apps/replybot/onboarding');
      }
    };

    callBackendCallback();
  }, [location, user, navigate]);

  return (
    <div className="h-screen w-full flex items-center justify-center">
      <Loader2 className="animate-spin h-6 w-6 mr-2" />
      Connecting WhatsApp account...
    </div>
  );
}
